const StorageConstants = {
  ROUTE_HISTORY: 'routeHistory',
  STACK: 'currentStack',
  GO_BACK_CB: 'goBackCallBack',
  PREVIOUS_ROUTE: 'previousRoute',
  NEW_USER: 'isNewUser',
  USER_INFO: 'userInfo',
  IS_INTERNET_CONNECTED: 'isInternetConnected',
  TELEMETRY: 'TELEMETRY',
  TELEMETRY_EVENTS: 'TELEMETRY_EVENTS',
  TRACKING_PROPERTIES: 'TRACKING_PROPERTIES',
  IS_SELFIE_SKIPPED: 'IS_SELFIE_SKIPPED',
  AB_FLAG: 'AB_FLAG',
  UTM_SOURCE: 'UTM_SOURCE',
  LLP_FLAG: 'LLP_FLAG',
};

export default StorageConstants;
